import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import FileViewer from 'react-file-viewer';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import Button from '@mui/material/Button';

function FormModal(props) {
  const [showFile, setShowFile] = useState(false);
  const [linkToFile, setLinkToFile] = useState(null);
  const [downloading, setDownloading] = useState(false);
  console.log(props.data);
  useEffect(() => {
    window.addEventListener('mousemove', () => {
      if (
        document.getElementById('closeFormModalBtn') &&
        window.matchMedia('(min-width: 578px)').matches
      ) {
        document.getElementById('closeFormModalBtn').style.opacity = '1';
        setTimeout(() => {
          if (
            document.getElementById('closeFormModalBtn') &&
            window.matchMedia('(min-width: 578px)').matches
          ) {
            document.getElementById('closeFormModalBtn').style.opacity = '0';
          }
        }, 5000);
      }
    });
  }, []);

  const token = localStorage.getItem('kss_token');
  const getForm = async () => {
    if (token) {
      try {
        const res = await axios.get(
          `https://account-testing-be.herokuapp.com/forms/${props.data.APIEndpoint}`,
          {
            headers: {
              token: token,
            },
          }
        );

        if (res.data.fileURL) {
          setLinkToFile(res.data.fileURL);
          setDownloading(false);
          console.log(res.data.fileURL);
          const a = document.createElement('a');
          a.href = res.data.fileURL;
          a.style.display = 'none';
          a.setAttribute('download', true);

          a.click();
        } else {
          window.alert(res.data.message);
        }
      } catch (error) {
        setDownloading(false);
        console.log(error.response);
        window.alert(error.response.data.message);
      }
    } else {
      setDownloading(false);
      window.alert('Please login to use this feature');
    }
  };

  // useEffect(() => {
  //   getForm();
  // }, []);

  const type = 'docx';
  const { t } = useTranslation();

  return (
    <>
      <Modal
        show={props.show}
        onHide={() => props.handleModal(false)}
        animation={true}
        // className="formModal p-0"
      >
        <Modal.Header>
          <Modal.Title className="small">{props.data.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="formModalContent">
            <p style={{ textAlign: 'center', marginBottom: '8px' }}>
              {t('sections-Formsection-FormModal-FormNo')} {props.data.formId}
            </p>
            <p style={{ textAlign: 'center' }}>
              {props.data.deadline && (
                <span style={{ marginRight: '32px' }}>
                  {t('sections-Formsection-FormModal-Deadline')}{' '}
                  {props.data.deadline}
                </span>
              )}
              <span>
                {t('sections-Formsection-FormModal-FormVersion')}{' '}
                {props.data.uploaded}
              </span>
            </p>
            <div style={{ textAlign: 'center', margin: '16px 0px' }}>
              {downloading ? (
                <p style={{ textAlign: 'center' }}>
                  {t('sections-Formsection-FormModal-Downloading')}{' '}
                </p>
              ) : (
                <>
                  {token && (
                    <Button variant="contained" color="primary">
                      <a
                        href={props.data.file}
                        download
                        style={{ marginRight: '8px', color: 'white' }}
                      >
                        {t('sections-Formsection-FormModal-DownloadEmpty')}
                      </a>
                    </Button>
                  )}
                  {token ? (
                    <Button
                      variant="contained"
                      color="primary"
                      style={{ color: 'white' }}
                      onClick={() => {
                        getForm();
                        setDownloading(true);
                      }}
                    >
                      {t('sections-Formsection-FormModal-DownloadAuto')}
                    </Button>
                  ) : (
                    <Button variant="contained" color="primary">
                      <a
                        href={props.data.file}
                        download
                        style={{ marginRight: '8px', color: 'white' }}
                      >
                        {t('sections-Formsection-FormModal-DownloadForm')}
                      </a>
                    </Button>
                  )}
                </>
              )}
            </div>
          </div>
          {showFile ? (
            <FileViewer fileType={type} filePath={props.data.file} />
          ) : (
            ''
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default FormModal;
